import { enUS, ptBR } from "date-fns/locale";

import type { AppLocale } from "../lib";

export const notificationDateLocale = (locale: AppLocale) => (locale === "pt-BR" ? ptBR : enUS);
